export const getTextFields = (profileData: any) => [
  {
    id: "profile-name",
    name: "fullName",
    label: "Name",
    type: "text",
    placeholder: "Enter Name",
    required: true,
    disabled: false,
    capitalizedFirst: true,
    value: profileData?.fullName,
  },
  {
    id: "profile-email",
    name: "email",
    label: "Email",
    type: "text",
    placeholder: "Enter Email",
    required: false,
    disabled: true,
    value: profileData?.email,
  },
  {
    id: "profile-phone",
    name: "phone",
    label: "Phone",
    type: "text",
    placeholder: "Enter Phone",
    required: true,
    disabled: false,
    value: profileData?.phone,
  },
  {
    label: "Gender",
    value: profileData?.gender,
    formField: false,
  },
];


export const getChangePasswordTextFields = () => [
  {
    id: "old-password",
    name: "oldPassword",
    label: "Current Password",
    placeholder: "Enter Current password",
    type: "password",
    required: true,
  },
  {
    id: "new-password",
    name: "newPassword",
    label: "New Password",
    placeholder: "Enter password",
    type: "password",
    required: true,
  },
  {
    id: "confirm-password",
    name: "confirmPassword",
    label: "Confirm Password",
    placeholder: "Confirm new password",
    type: "password",
    required: true,
  },
];
export const getSignatureTextFields = (signatureData: any) => [
  {
    label: "Signature",
    value: signatureData?.signature,
    formField: false,
  },
];
export const getSignatureFields = (profileData: any) => [
  {
    id: "profile-signatureText",
    name: "signatureText",
    label: "Signature",
    type: "text",
    placeholder: "Enter Signature ",
    required: true,
    value: profileData?.signatureText,
    multiline: true,
  },
];
export const getTwoFactorAuthenticationFields = (
  twoFactorAuthenticationData: any
) => [
  {
    id: "twoFactorAuthentication-status",
    name: "secretKey",
    label: "Secret PIN",
    type: "text",
    placeholder: "Enter Your Secret PIN",
    required: true,
    value: twoFactorAuthenticationData?.status,
  },
];
export const getOtpDataFields = (otpData: any) => [
  {
    id: "twoFactorAuthentication-status",
    name: "otp",
    label: "OTP",
    type: "text",
    placeholder: "Enter OTP",
    required: true,
    value: otpData?.otp,
  },
];
